/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as TYPES from './action-types';
const intialState = {
  loading: false,
  stateAbbrevations: [],
  invoices: [],
  pageData: {},
  errorMessages: [],
  successMessages: [],
  selectType: '',
  planType: '',
  rebateProgram: null,
  startDate: null,
  endDate: null,
  errors: {},
  rbtPrgDD: [],
};

const reducer = (state = intialState, action) => {
  switch (action.type) {
    case TYPES.TRANSITION_DATA_INVOICE_LOADING:
      return { ...state, loading: action.payload };
    case TYPES.TRANSITION_DATA_INVOICE_DATA:
      return { ...state, invoices: action.payload };
    case TYPES.TRANSITION_DATA_STATE_DATA:
      return { ...state, stateAbbrevations: action.payload };
    case TYPES.TRANSITION_DATA_COMPONENT_STATE:
      return { ...state, pageData: action.payload };
    case TYPES.SET_ERROR_MESSAGES:
      return { ...state, errorMessages: action.payload };
    case TYPES.SET_SUCCESS_MESSAGES:
      return { ...state, successMessages: action.payload };
    case TYPES.SET_SELECT_TYPE:
      return { ...state, selectType: action.payload };
    case TYPES.SET_PLAN_TYPE:
      return { ...state, planType: action.payload };
    case TYPES.SET_REBATE_PROGRAM:
      return { ...state, rebateProgram: action.payload };
    case TYPES.SET_START_DATE:
      return { ...state, startDate: action.payload };
    case TYPES.SET_END_DATE:
      return { ...state, endDate: action.payload };
    case TYPES.SET_ERRORS:
      return { ...state, errors: action.payload };
    case TYPES.SET_REBATE_PROGRAM_DD:
      return { ...state, rbtPrgDD: action.payload };
    case TYPES.RESET_TRANSITION_DATA_STORE:
      return { ...intialState };
    default:
      return { ...state };
  }
};

export default reducer;
